import { createSelector } from 'reselect';

import { getExperimentalPageData } from 'src/universal/redux/page';
import { getOneXpExperiments } from 'src/universal/redux/oneXp';

export const showG162Banner = createSelector(
  [getOneXpExperiments, (_, activeFilter) => activeFilter, getExperimentalPageData],
  (oneXpExperiments, activeFilter, experimentData) => {
    const isAllowedFilter = Object.keys(
      experimentData?.g162?.bannerData || {}
    ).includes(activeFilter);
    return (
      oneXpExperiments['GCS-162-Compare-Banner-VAC']?.dimensions[0]?.variant ===
        'experiment' && isAllowedFilter
    );
  }
);

export const getLoadedIntoG162Experiment = createSelector(
  [getOneXpExperiments],
  oneXpExperiments => {
    return (
      oneXpExperiments['GCS-162-Compare-Banner-VAC']?.dimensions[0]?.variant ===
      'experiment'
    );
  }
);

export const getG162Data = createSelector(
  [getExperimentalPageData, (_, activeFilter) => activeFilter],
  (experimentData, activeFilter) => {
    const g162 = experimentData?.g162?.bannerData;
    const logo = g162?.logo;
    return {
      filterData: g162[activeFilter],
      g162Logo: logo
    };
  }
);

export const getG162AllCards = createSelector(
  [getExperimentalPageData],
  experimentData => {
    return experimentData?.g162?.allCardsArt;
  }
);
